import '../../assets/styles/Switcher.css'

import { Field, Label, Switch } from '@headlessui/react'
import { useState } from 'react'

export function Switcher() {
  const [enabled, setEnabled] = useState(false)

  return (
    <Field className="flex gap-2 items-center tc-mv-switcher-container">
      <Switch
        checked={enabled}
        onChange={setEnabled}
        className="bg-gray-200 h-4 rounded-full w-7 group inline-flex items-center tc-mv-switcher transition"
      >
        <span className="bg-white rounded-full group-data-[checked]:translate-x-4 size-[14px] transition translate-x-0" />
      </Switch>
      <Label>QA Mode</Label>
    </Field>
  )
}
